// ProductType Vuex

import state from './productTypeStates.js'
import * as getters from './productTypeGetters.js'
import * as mutations from './productTypeMutations.js'
import * as actions from './productTypeActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
